import { Link } from 'react-router-dom';
import { getFeaturedArticles } from '@/mocks/articles';

export default function ArticlesSection() {
  const featuredArticles = getFeaturedArticles();

  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-4">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">
              精选文章
            </h2>
            <p className="text-sm text-foreground-500">
              社区达人们的经验分享和深度好文
            </p>
          </div>
          <Link
            to="/category/outdoor"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="text-sm text-primary-500 hover:text-primary-600 font-label whitespace-nowrap flex items-center gap-1 cursor-pointer"
          >
            更多文章 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="bg-background-100 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors duration-300 group cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="bg-secondary-500 text-background-50 text-xs px-2.5 py-1 rounded-full font-label whitespace-nowrap">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-label font-medium text-foreground-900 mb-2 line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i> {article.readTime}
                  </span>
                  <span>{article.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}